export const patriotic = [
  {
    number: 'HP100',
    hasModel: false
  },
  {
    number: 'HP101',
    hasModel: false
  },
  {
    number: 'HP102',
    hasModel: false
  },
  {
    number: 'HP103',
    hasModel: false
  },

]